import TextField from "@mui/material/TextField";
import CropYearDatePicker from "../CropYearDatePicker";

export default function OperationDetailsFields({
  operation = {},
  onChange,
  dateField = "operation_date",
  dateLabel = "Operation Date",
  error = false,
  cropYear,
}) {
  return (
    <div className="mb-5 mt-4 grid w-full max-w-[520px] grid-cols-1 gap-3 sm:grid-cols-[190px_170px]">
      <CropYearDatePicker
        cropYear={cropYear}
        label={dateLabel}
        value={(operation?.[dateField] || "").slice(0, 10)}
        onChange={(value) => onChange(dateField, value)}
        textFieldProps={{ error, fullWidth: true }}
      />
      <TextField
        type="number"
        size="small"
        label="Fuel Used (L)"
        value={operation?.fuel_used_litres ?? ""}
        onChange={(event) => onChange("fuel_used_litres", event.target.value)}
        inputProps={{ min: 0, step: "any" }}
        helperText={error ? "Use zero or a positive amount." : "Optional litres for this field pass. Not converted to Holos energy; see Review."}
        fullWidth
      />
    </div>
  );
}
